// extracted by mini-css-extract-plugin
export var carrierNotice = "_hg-5";
export var carrierNoticePlaceholder = "_hg-6";
export var deliveryRow = "_hg-c";
export var fixedHeight = "_hg-4";
export var freightLogo = "_hg-b";
export var fullWidth = "_hg-3";
export var priceColumn = "_hg-7";
export var radioSelected = "_hg-9";
export var radioUnselected = "_hg-8";
export var selectedOption = "_hg-2";
export var selectedOptionContainer = "_hg-1";
export var selection = "_hg-0";
export var tallSkeletonText = "_hg-a";